import React from 'react';

import { Grid } from '../../../models';

interface GridHorizontalStreakProps {
  width: number;
  height: number;
  grid: Grid;
}

export default function GridHorizontalStreak({
  width,
  height,
  grid
}: GridHorizontalStreakProps) {
  const step = grid.properties.step;
  let colors: string[];

  if (grid.properties.color) {
    colors = [grid.properties.color];
  } else {
    colors = grid.properties.colors;
  }

  const rendered = [];
  let i = 0;
  for (let y = 0; y <= height; y += step) {
    const color = colors[i % colors.length];
    i++;
    rendered.push(
      <line
        key={y}
        x1="0"
        y1={y}
        x2={width}
        y2={y}
        strokeWidth="1"
        stroke={color}
      />
    );
  }

  return <g>{rendered}</g>;
}
